import { Listbox } from '@headlessui/react';
import last from 'lodash/last';
import { useRouter } from 'next/dist/client/router';
import { Dispatch, useEffect, useState } from 'react';
import useFilter from '../../../../lib/hooks/filters';
import { SingleFilter } from '../../../../lib/types';
import SortIcon from '../../../icons/Sort';
import StandardFilterOptions from '../../../shared/StandardFilterOptions';
import ActiveFilter from './ActiveFilter';

interface FilterProps {
  defaultFilters?: any[];
  filterOptions: any[];
  label: string;
  paramLabel: string;
  isMultiple: boolean;
  updatePotentialFilterForParam: (fitler: SingleFilter) => void;
  potentialNumberOfResults: number;
  seeAllResults: () => void;
  setPage: Dispatch<number>
}

const DesktopFilter: React.FC<FilterProps> = ({
  defaultFilters,
  filterOptions,
  label,
  paramLabel,
  isMultiple,
  potentialNumberOfResults,
  seeAllResults,
  updatePotentialFilterForParam,
  setPage
}) => {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultFilters || ([] as any[]),
  );
  const [activeFilters, setActiveFilters] = useState([] as string[]);
  const router = useRouter();

  useEffect(() => {
    const params = router.query;
    if (params[paramLabel]) {
      setSelectedFilters(
        decodeURI(params[paramLabel] as string).split('_') as string[],
      );
      setActiveFilters((params[paramLabel] as string).split('_'));
    } else {
      setSelectedFilters([]);
      setActiveFilters([]);
    }
  }, [router]);

  const { clearSelectedFilters } = useFilter(
    selectedFilters,
    paramLabel,
    setSelectedFilters,
    updatePotentialFilterForParam,
  );

  return (
    <div className="flex-1">
      <Listbox
        className="relative"
        value={selectedFilters}
        onChange={(selected: any) => {
          if (!isMultiple && !selected.length) return;

          if (!isMultiple) {
            setSelectedFilters([last(selected)]);
            return;
          }
          setSelectedFilters(selected);
        }}
        multiple
        as="div"
      >
        <Listbox.Button className="items-center justify-between hidden min-w-full px-2 py-4 border-2 border-solid career-filter lg:flex border-careerPageHighlight hover:border-white">
          <p className="text-lg font-light text-white whitespace-nowrap">
            {label}
          </p>
          <SortIcon className="w-4 h-4 ml-2 fill-white" />
        </Listbox.Button>
        <div className="hidden lg:block">
          <Listbox.Options className="absolute top-22 -left-6 min-w-full cursor-pointer bg-white z-20 shadow-filter  pb-[5rem] w-80 outline-none py-2">
            <div className="overflow-y-scroll max-h-80 ">
              <StandardFilterOptions
                filterOptions={filterOptions}
                paramLabel={paramLabel}
              />

              <div className="absolute bottom-0 left-0 right-0 grid px-6 py-4 m-0 text-center bg-white shadow-2xl grid-cols-filter">
                <button
                  className="font-bold text-careerPageHeading font-base"
                  onClick={clearSelectedFilters}
                  tabIndex={1}
                >
                  Clear
                </button>
                <Listbox.Button
                  className="bg-careerPageHighlight  w-[175px] ml-auto py-3 font-base font-bold rounded-full text-white"
                  tabIndex={1}
                >
                  <button onClick={seeAllResults}>
                    See {potentialNumberOfResults || 0} Results
                  </button>
                </Listbox.Button>
              </div>
            </div>
          </Listbox.Options>
        </div>
      </Listbox>
      <div className="hidden grid-cols-2 gap-1 my-4 lg:grid">
        {activeFilters.map((filter) => (
          <ActiveFilter
            setPage={setPage}
            filter={filter}
            paramLabel={paramLabel}
          />

        ))}
      </div>
    </div>
  );
};

export default DesktopFilter;
